export default {
  CREATE_ORDER_PAYMENT(state, payload) {},
  CREATE_PAYMENT(state, payload) {},
  UPDATE_PAYMENT(state, payload) {},
  GET_ALL_PAYMENT(state, payload) {
    state.getAllPayments = payload;
  },
};
